import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { BtnDownload } from "../btnDownload";
import { BtnWhatsapp } from "../btnWhatsapp";
import LogoOficialColor from "../../assets/imgs/JC Congresos y convenciones.png";
import LogoOficial from "../../assets/imgs/JC-Congresos-y-convenciones-blanco.png";

import "./header.scss";
import { useTranslation } from "react-i18next";

import ico01 from "../../assets/imgs/iconos/services_home/org_congresos.svg";
import ico02 from "../../assets/imgs/iconos/services_home/prod_visual.svg";
import ico03 from "../../assets/imgs/iconos/services_home/envivo.svg";
import ico04 from "../../assets/imgs/iconos/services_home/develop.svg";
import ico05 from "../../assets/imgs/iconos/services_home/design.svg";
import ico06 from "../../assets/imgs/iconos/services_home/marketing.svg";

export const Header = () => {
  const [scrollTop, setScrollTop] = useState(0);
  const [Lenguage, setLenguage] = useState(true);

  useEffect(() => {
    const updateScroll = () => {
      const scrollY = window.scrollY;
      setScrollTop(scrollY);
    };
    updateScroll();
    window.addEventListener("scroll", updateScroll);
  });

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [openMenu, setOpenMenu] = useState("");

  const handlerMenu = () => {
    setOpenMenu(openMenu === "" ? "open__menu" : "");
  };

  const handlSubMenu = () => {
    setOpenMenu(openMenu === "" ? "open__menu" : "");
    setDropdownOpen((prevState) => !prevState);
  };

  const { t, i18n } = useTranslation();

  const ChageLenguage = () => {
    if (Lenguage) {
      setLenguage(false);
      i18n.changeLanguage("en");
    } else {
      setLenguage(true);
      i18n.changeLanguage("es");
    }
  };

  let asd = Lenguage ? "switch-button__labelEN " : "switch-button__label";
  return (
    <>
      <header
        className={`wrapper_header trans ${
          scrollTop > 10 ? "header_change" : ""
        } `}
      >
        <div className="header_top">
          <div className="container-lg">
            <div className="sec_top">
              <div className="box_info_business">
                {/* <a href="tel:+5565865748">
                  <i className="fa-solid fa-phone pt-1"></i> (556) 586 5748{" "}
                </a> */}
              </div>
              <div className="box_social_networks">
                {/* <span>{t("Síguenos en:")}</span> */}
                <a href="tel:+5565865748">
                  <i className="fa-solid fa-phone pt-1"></i> (556) 586 5748{" "}
                </a>
                <a
                  target="_blank"
                  title="Facebook"
                  rel="nofollow noopener noreferrer"
                  href="https://www.facebook.com/jcinnovationoficial"
                >
                  <i className="fa-brands fa-facebook-square"></i>
                </a>
                <a
                  target="_blank"
                  title="Instagram"
                  rel="nofollow noopener noreferrer"
                  href="https://www.instagram.com/jcinnovationoficial/"
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <a
                  target="_blank"
                  title="Linkedin"
                  rel="nofollow noopener noreferrer"
                  href="https://www.linkedin.com/company/jc-innovation/"
                >
                  <i className="fa-brands fa-linkedin"></i>
                </a>
                <div className="switch-button">
                  <input
                    onClick={ChageLenguage}
                    type="checkbox"
                    name="switch-button"
                    id="switch-label"
                    className="switch-button__checkbox"
                  ></input>

                  <label htmlFor="switch-label" className={asd + ""}>
                    {" "}
                  </label>
                  <p
                    className={`textLen ${
                      Lenguage ? "textLen-traslationES" : "textLen-traslationEN"
                    }`}
                  >
                    {Lenguage ? "ES" : "EN"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-lg">
          <div className="header_botton">
            <div className="sec_brand">
              <Link to="/">
                {scrollTop > 10 ? (
                  <img
                    className="logo_brand"
                    src={LogoOficialColor}
                    alt="JC Innovations"
                  />
                ) : (
                  <img
                    className="logo_brand"
                    src={LogoOficial}
                    alt="JC Innovations"
                  />
                )}
              </Link>
            </div>
            <div className="sec_options">
              <nav className={`nav_options_item ${openMenu}`}>
                <ul className="ul_nav_master">
                  <li className="li_nav_master" onClick={handlerMenu}>
                    <Link className="item_link" to="/">
                      {t("INICIO")}
                    </Link>
                  </li>
                  <li className="li_nav_master" onClick={handlerMenu}>
                    <Link className="item_link" to="/nosotros">
                      {t("NOSOTROS")}
                    </Link>
                  </li>
                  <li className="li_nav_master">
                    <div className="btn-group">
                      <span
                        type="button"
                        className="item_link dropdown__toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {t("SERVICIOS")}
                      </span>
                      <ul className="dropdown-menu">
                        <li>
                          <Link
                            to="/organizacion-congresos"
                            className="dropdown-item"
                            onClick={handlerMenu}
                          >
                            <img
                              src={ico01}
                              alt={t("Organización de Congresos")}
                            />
                            <span>{t("Organización de Congresos")}</span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/produccion-audiovisual"
                            className="dropdown-item"
                            onClick={handlerMenu}
                          >
                            <img
                              src={ico02}
                              alt={t("Producción Audiovisual")}
                            />
                            <span>{t("Producción Audiovisual")}</span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/streaming"
                            className="dropdown-item"
                            onClick={handlerMenu}
                          >
                            <img src={ico03} alt={t("Streaming")} />
                            <span>{t("Streaming")}</span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/desarrollo-web-apps"
                            className="dropdown-item"
                            onClick={handlerMenu}
                          >
                            <img src={ico04} alt={t("Desarrollo Web y Apps")} />
                            <span>{t("Desarrollo Web y Apps")}</span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/diseno-grafico"
                            className="dropdown-item"
                            onClick={handlerMenu}
                          >
                            <img src={ico05} alt={t("Diseño Gráfico")} />
                            <span>{t("Diseño Gráfico")}</span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/marketing-y-redes-sociales"
                            className="dropdown-item"
                            onClick={handlerMenu}
                            href="#"
                          >
                            <img
                              src={ico06}
                              alt={t("Marketing y Redes Sociales")}
                            />
                            <span>{t("Marketing y Redes Sociales")}</span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="li_nav_master" onClick={handlerMenu}>
                    <HashLink
                      className="item_link"
                      smooth
                      to="/#aliados"
                      scroll={(el) => {
                        setTimeout(() => {
                          el.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          });
                        }, 100); // 100ms para dar chance al render
                      }}
                    >
                      ALIADOS
                    </HashLink>
                  </li>
                  <li className="li_nav_master" onClick={handlerMenu}>
                    <Link className="item_link" to="/blog">
                      {/* {t("NOSOTROS")} */}
                      BLOG
                    </Link>
                  </li>
                  <li className="li_nav_master" onClick={handlerMenu}>
                    <Link className="item_link" to="/contacto">
                      {/* {t("NOSOTROS")} */}
                      CONTACTO
                    </Link>
                  </li>
                  {/* <div className="dwld_box">
                    <BtnDownload />
                  </div> */}
                </ul>
              </nav>
              <div className="box_options_btns">
                <BtnDownload />

                <span className="btn_menu" onClick={handlerMenu}>
                  <i className="fa-solid fa-bars"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container-lg btn__wp trans">
          <BtnWhatsapp />
        </div> */}
      </header>
    </>
  );
};
